import { render, staticRenderFns } from "./logTable.vue?vue&type=template&id=c74f4e98&scoped=true"
import script from "./logTable.vue?vue&type=script&lang=js"
export * from "./logTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c74f4e98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c74f4e98')) {
      api.createRecord('c74f4e98', component.options)
    } else {
      api.reload('c74f4e98', component.options)
    }
    module.hot.accept("./logTable.vue?vue&type=template&id=c74f4e98&scoped=true", function () {
      api.rerender('c74f4e98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/compensationManagement/compensationList/components/logTable.vue"
export default component.exports